export default __webpack_public_path__ + "static/media/0x32934cb16da43fd661116468c1b225fc26cf9a8c.87acf925.png";